/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, submit, change, getFormSubmitErrors, formValueSelector } from 'redux-form';
import { TextField, Toggle, DatePicker, SelectField } from 'redux-form-material-ui';
import { MenuItem, FlatButton, Dialog, IconButton } from 'material-ui';
import InfoIcon from 'material-ui/svg-icons/action/info';
import CheckCirlceIcon from 'material-ui/svg-icons/action/check-circle';
import HighlighOffIcon from 'material-ui/svg-icons/action/highlight-off';
import TimerIcon from 'material-ui/svg-icons/image/timer';
import NotificationIcon from 'material-ui/svg-icons/social/notifications-none';
import CastIcon from 'material-ui/svg-icons/hardware/cast';
import moment from 'moment';
import _ from 'lodash';
import timezones from 'google-timezones-json';
import { CAMPAIGN_FORM_ID, CAMPAIGN_FORM_KEYS, LANGUAGES, TIMEZONE_BUTTONS } from 'dash-front/constants';
import RulesArray from './RulesArray';
import SMLinkAddButtons from '../SMLink/SMLinkManager';
import { RowSection, ActiveLabel, yCenter, marginLeft, formatDate } from '../../components/helpers';
import ErrorComponent from '../../components/Form/Error';
import { presence } from 'dash-front/helpers/validation';
import TargetsForm from '../../components/Form/TargetsForm';
import NotificationsForm from '../../components/Form/NotificationsForm';
import EmojiPicker from '../../components/Form/pickers/REmojiPicker';
import { withActiveFormProps, withTargetsFormProps, withTemplates } from '../../enhancers';
import { fetchWidgetSpecs, fetchTemplates } from 'dash-front/actions';
import { fetchSmlinks } from 'dash-front/campaign/actions/smlinks';
import { UI_ACTIONS } from 'dash-front/reducers/ui';

const timezoneKeys = Object.keys(timezones);

const iconStyle = {
    width: 40,
    height: 40,
    color: '#3f51b5',
};

const yCenterXSpaceBetween = {
    ...yCenter,
    ...{ justifyContent: 'space-between', width: 300 },
};

const TemplatesForm = ({ templates = [] }) => (
    <div>
        <Field
            name={CAMPAIGN_FORM_KEYS.TEMPLATE}
            floatingLabelText="Template"
            style={{ width: '300px' }}
            validate={presence}
            component={SelectField}
        >
            {templates
                .filter(t => !t.isHidden)
                .map(t => (
                    <MenuItem key={t.id} primaryText={t.name} value={t.id} />
                ))}
        </Field>
    </div>
);

const TargetsFormEnhanced = withTargetsFormProps(TargetsForm);
const TemplatesFormEnhanced = withTemplates(TemplatesForm);
const ActiveLabelEnhanced = withActiveFormProps(ActiveLabel);

const errSelect = state => {
    const value = _.get(getFormSubmitErrors(CAMPAIGN_FORM_ID)(state), '_error_');
    return { value };
};
const ErrorEnhanced = connect(errSelect)(ErrorComponent);

const ClearButton = connect(
    (state, { name }) => ({
        clear: !formValueSelector(CAMPAIGN_FORM_ID)(state, name),
    }),
    (dispatch, { name }) => ({
        onClick: () => dispatch(change(CAMPAIGN_FORM_ID, name, '')),
    }),
)(({ clear, onClick, ...rest }) =>
    clear ? null : (
        <IconButton {...rest} onTouchTap={onClick}>
            <HighlighOffIcon />
        </IconButton>
    ),
);

const TimezoneFastSelect = ({ onChange }) => {
    return (
        <div>
            {TIMEZONE_BUTTONS.map(key => (
                <FlatButton key={key} onTouchTap={() => onChange(key)} label={timezones[key]} />
            ))}
        </div>
    );
};
const mapDispatchToProps = dispatch => {
    return {
        onChange: timezone => {
            dispatch(change(CAMPAIGN_FORM_ID, CAMPAIGN_FORM_KEYS.TIMEZONE, timezone));
        },
    };
};
const TimezoneFastSelectEnhanced = connect(
    null,
    mapDispatchToProps,
)(TimezoneFastSelect);

const SMLinkCreate = ({ open, onOpen, onClose }) => (
    <div>
        <a
            style={{
                color: 'rgb(63, 81, 181)',
                cursor: 'pointer',
                fontSize: 14,
                textDecoration: 'underline',
            }}
            onClick={onOpen}
        >
            Link social account
        </a>
        <Dialog open={open} onRequestClose={onClose}>
            <SMLinkAddButtons />
        </Dialog>
    </div>
);

const mapStateToPropsSMLinkCreate = state => ({
    open: Boolean(state.ui.smlinkDialogOpen),
});
const mapDispatchToPropsSMLinkCreate = dispatch => ({
    onOpen: () =>
        dispatch({
            type: UI_ACTIONS.CHANGE,
            key: 'smlinkDialogOpen',
            value: true,
        }),
    onClose: () =>
        dispatch({
            type: UI_ACTIONS.CHANGE,
            key: 'smlinkDialogOpen',
            value: false,
        }),
});
const SMLinkCreateEnhanced = connect(
    mapStateToPropsSMLinkCreate,
    mapDispatchToPropsSMLinkCreate,
)(SMLinkCreate);

const InfoForm = () => (
    <div>
        <Field
            name={CAMPAIGN_FORM_KEYS.TITLE}
            validate={presence}
            floatingLabelText="Enter campaign name"
            component={TextField}
        />
        <div style={{ display: 'flex' }}>
            <Field
                name={CAMPAIGN_FORM_KEYS.LANGUAGE}
                floatingLabelText="Language"
                component={SelectField}
                style={{ width: '30%' }}
            >
                {LANGUAGES.map(lang => (
                    <MenuItem key={lang.key} primaryText={lang.name} value={lang.key} />
                ))}
            </Field>
            <div style={{ width: '70%' }}>
                <Field
                    name={CAMPAIGN_FORM_KEYS.TIMEZONE}
                    floatingLabelText="Timezone"
                    style={{ width: '300px' }}
                    validate={presence}
                    component={SelectField}
                >
                    {timezoneKeys.map(key => (
                        <MenuItem key={key} primaryText={timezones[key]} value={key} />
                    ))}
                </Field>
                <TimezoneFastSelectEnhanced />
            </div>
        </div>
        <div>
            <EmojiPicker name="defaultMessage" floatingLabelText="Default post message" multiLine />
        </div>
        <div>
            <EmojiPicker name="signature" floatingLabelText="Signature (hashtags)" />
        </div>

        <div>
            <div style={{ width: 150, marginTop: 16, marginBottom: 16 }}>
                <Field label="Calendar" name={CAMPAIGN_FORM_KEYS.CALENDAR} component={Toggle} />
            </div>
        </div>
    </div>
);

const onStartDateChange = startDate => (dispatch, getState) => {
    if (startDate) {
        const endDate = formValueSelector(CAMPAIGN_FORM_ID)(getState(), 'endDate');
        if (endDate && moment(endDate).diff(moment(startDate), 'days') <= 0) {
            dispatch(change(CAMPAIGN_FORM_ID, 'endDate', ''));
        }
    }
};

const ActiveForm = connect(
    state => ({
        startDate: formValueSelector(CAMPAIGN_FORM_ID)(state, 'startDate'),
        timezone: formValueSelector(CAMPAIGN_FORM_ID)(state, 'timezone'),
    }),
    dispatch => ({
        onStartChange: val => dispatch(onStartDateChange(val)),
    }),
)(({ startDate, onStartChange }) => {
    const minDateEnd = startDate
        ? moment(startDate)
              .add(1, 'days')
              .toDate()
        : new Date();
    return (
        <div>
            <div style={{ width: 150 }}>
                <Field name={CAMPAIGN_FORM_KEYS.ACTIVE} label="Active" component={Toggle} />
            </div>
            <div style={yCenterXSpaceBetween}>
                <Field
                    name={CAMPAIGN_FORM_KEYS.START_DATE}
                    floatingLabelText="Start"
                    format={formatDate}
                    onChange={(e, val) => onStartChange(val)}
                    style={{ width: 100 }}
                    textFieldStyle={{ width: '100%' }}
                    component={DatePicker}
                />
                <ClearButton name="startDate" style={{ marginTop: 24 }} />
                <Field
                    name={CAMPAIGN_FORM_KEYS.END_DATE}
                    floatingLabelText="End"
                    format={formatDate}
                    minDate={minDateEnd}
                    style={{ width: 100, marginLeft: 24 }}
                    textFieldStyle={{ width: '100%' }}
                    component={DatePicker}
                />
                <ClearButton name="endDate" style={{ marginTop: 24 }} />
            </div>
        </div>
    );
});

class CampaignForm extends React.Component {
    componentDidMount() {
        const {
            user: { client },
        } = this.context;
        const { dispatch } = this.props;
        dispatch(fetchSmlinks());
        dispatch(fetchWidgetSpecs(client));
        dispatch(fetchTemplates());
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    onSubmitTap = () => {
        const { dispatch } = this.props;
        dispatch(submit(CAMPAIGN_FORM_ID));
    };

    render() {
        return (
            <div>
                <ErrorEnhanced />
                <RowSection
                    leftContent={
                        <div>
                            <InfoIcon style={iconStyle} />
                            <h4 style={marginLeft()}>Campaign info</h4>
                        </div>
                    }
                    rightContent={<InfoForm />}
                />
                <RowSection
                    leftContent={
                        <div>
                            <InfoIcon style={iconStyle} />
                            <h4 style={marginLeft()}>Templates</h4>
                        </div>
                    }
                    rightContent={<TemplatesFormEnhanced />}
                />

                <RowSection
                    leftContent={
                        <div>
                            <NotificationIcon style={iconStyle} />
                            <h4 style={marginLeft()}>Notifications</h4>
                        </div>
                    }
                    rightContent={
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '50%' }}>
                                <NotificationsForm />
                                <div style={{ width: 150, marginTop: 12 }}>
                                    <Field label="Moderated" name={CAMPAIGN_FORM_KEYS.MODERATION} component={Toggle} />
                                </div>
                            </div>
                            <div
                                style={{
                                    width: '50%',
                                    color: 'rgba(0, 0, 0, 0.4)',
                                    padding: 24,
                                }}
                            >
                                <i>Created posts will NOT be published until manual approval.</i>
                                <br />
                                <i>Subscribers will be notified about all new posts required moderation.</i>
                            </div>
                        </div>
                    }
                />
                <RowSection
                    leftContent={
                        <div>
                            <CastIcon style={iconStyle} />
                            <div>
                                <h4 style={marginLeft()}>Social Media Channels</h4>
                                <div style={{ marginLeft: 12 }}>
                                    <SMLinkCreateEnhanced />
                                </div>
                            </div>
                        </div>
                    }
                    rightContent={<TargetsFormEnhanced />}
                />
                <RowSection
                    leftContent={
                        <div>
                            <CheckCirlceIcon style={iconStyle} />
                            <div style={marginLeft()}>
                                <ActiveLabelEnhanced />
                            </div>
                        </div>
                    }
                    rightContent={<ActiveForm />}
                />
                <RowSection
                    leftContent={
                        <div>
                            <TimerIcon style={iconStyle} />
                            <div style={marginLeft()}>
                                <h4>Rules & triggers</h4>
                            </div>
                        </div>
                    }
                    rightContent={<FieldArray name={CAMPAIGN_FORM_KEYS.RULES.ARRAY} component={RulesArray} />}
                />
            </div>
        );
    }
}

CampaignForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect()(CampaignForm);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/CampaignForm.js
 **/